export enum PermissionEnum {
  READ = 'read',
  EDIT = 'edit',
}
